<div class="px-2 md:px-10 pt-2 md:pt-5">
  <h1 class="w-full text-center text-3xl font-bold mb-10">
    {{ "legal.title" | translate }}
  </h1>
  <p class="font-bold">
    {{ "legal.paragraph1" | translate }}
    <br />
    <br />
    {{ "legal.paragraph2_part1" | translate }}
    <a
      class="text-red-500 underline"
      href="www.orias.fr"
      >{{ "legal.orioas" | translate }}</a
    >
    {{ "legal.paragraph2_part2" | translate }}
    <br />
    <br />
    {{ "legal.date" | translate }}
  </p>
</div>
